// import React, { ReactNode } from "react";

// interface ModalProps {
//   isOpen: boolean;
//   showCloseButton?: boolean;
//   onClose?: () => void;
//   children: ReactNode;
//   width?: string;
// }

// const CustomModal: React.FC<ModalProps> = ({
//   isOpen,
//   onClose,
//   children,
//   showCloseButton = true,
//   width = "min-w-96",
// }) => {
//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 flex items-center justify-center z-50 bg-black-900 bg-opacity-50">
//       <div className={`bg-white-a700 rounded-lg p-6 shadow-lg relative mb-12 ${width}`}>
//         {showCloseButton && (
//           <button
//             className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 pr-2 text-2xl"
//             onClick={onClose}>
//             &times;
//           </button>
//         )}
//         <div className={`w-full ${showCloseButton && "mt-4"}`}>{children}</div>
//       </div>
//     </div>
//   );
// };

// export default CustomModal;

import React, { ReactNode } from "react";
import clsx from "clsx"; // Make sure to import clsx

interface ModalProps {
  isOpen: boolean;
  showCloseButton?: boolean;
  onClose?: () => void;
  children: ReactNode;
  width?: string;
  rounded?: "sm" | "md" | "lg" | "xl" | "2xl" | "3xl" | "full"; // Added rounded prop
}

const CustomModal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  showCloseButton = true,
  width = "min-w-96",
  rounded = "lg", // Default rounded value
}) => {
  if (!isOpen) return null;

  // Use clsx to conditionally apply classes
  const containerClasses = clsx(
    "bg-white-a700 p-6 shadow-lg relative mb-12",
    width,
    {
      "rounded-sm": rounded === "sm",
      "rounded-md": rounded === "md",
      "rounded-lg": rounded === "lg",
      "rounded-xl": rounded === "xl",
      "rounded-2xl": rounded === "2xl",
      "rounded-3xl": rounded === "3xl",
      "rounded-full": rounded === "full",
    }
  );

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black-900 bg-opacity-50">
      <div className={containerClasses}>
        {showCloseButton && (
          <button
            className="absolute top-2 right-2 text-gray-600 hover:text-gray-900 pr-2 text-2xl"
            onClick={onClose}>
            &times;
          </button>
        )}
        <div className={`w-full ${showCloseButton && "mt-4"}`}>{children}</div>
      </div>
    </div>
  );
};

export default CustomModal;